module.exports = __webpack_public_path__ + "static/media/fire-specs.f6b1b7cc.png";